import { FC } from 'react';
import { Container } from '@/components/ui/Container';
import { CloudServiceAd } from '@/components/ui/CloudServiceAd';

export const CloudServiceSection: FC = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-blue-50">
      <Container>
        <CloudServiceAd />
      </Container>
    </section>
  );
};